import { render, staticRenderFns } from "./IlamliNafakaAlacakFormWizard.vue?vue&type=template&id=0b547d16"
import script from "./IlamliNafakaAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./IlamliNafakaAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports